import Address from 'src/models/Address';
import IOwner from 'src/models/IOwner';
import PhoneNumberChanges from 'src/models/PhoneNumberChanges';

export default class OwnerRAL implements IOwner {
    constructor(owner: OwnerRAL) {
        Object.assign(this, owner);
    }
    id: number;
    containerOwnerId: number;
    ownerLookUpId: number;
    email: string;
    addressInformationDate: Date;
    spouseFirstName: string;
    spouseLastName: string;
    stateId: number;
    address: Address;
    addressId: number;
    phoneNumberChanges?: PhoneNumberChanges;
    surfaceOwnerAgentPersonDetailsId: number;
    surfaceOwnerAgentFirstName: string;
    surfaceOwnerAgentLastName: string;
    ownerType: string;
    note: string;
    isPrimaryDeviation: boolean;
    isClientAcreage: boolean;
    ssnTaxId: string;

    ownerName() {
        return this.surfaceOwnerAgentFirstName + ' ' + this.surfaceOwnerAgentLastName;
    }
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/add_ownership_revised/OwnerRAL.ts